import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  modal: {
    justifyContent: 'flex-end',
    margin: 0
  },
  main: {
    backgroundColor: Colors.white
  },
  main_normal: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10
  },
  main_full: {
    borderRadius: 0,
    flex: 1
  },
  indicatorContainer_normal: {
    padding: 30,
    paddingBottom: 0,
    backgroundColor: Colors.transparent
  },
  indicatorContainer_full: {
    flex: 0
  },
  topIndicator_normal: {
    width: 45,
    height: 6,
    backgroundColor: Colors.whiteRGBA(0.5),
    alignSelf: 'center',
    marginBottom: 6,
    borderRadius: 3
  },
  topIndicator_full: {
    flex: 0
  },
  content: {
    flexGrow: 1
  }
})

export default styles
